import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceRegistMailMagazineModal',
  components: {
    Loading
  },
  data () {
    return {
      processing: false,

      // form
      inpMailAddress: null,
      inpTitle: null,
      inpBody: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceRegistMailMagazineModal.active,
      serviceId: state => state.serviceRegistMailMagazineModal.targetId,

      // model
      values: state => state.serviceRegistMailMagazineModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // result
    resultMailMagazineName () {
      return this.values.mailMagazineName
    },

    // validate
    inpMailAddressIsValid () {
      return Validator.validText(this.inpMailAddress)
    },
    inpTitleIsValid () {
      return Validator.validText(this.inpTitle)
    },
    inBodyIsValid () {
      return Validator.validText(this.inpBody)
    },
    formIsValid () {
      return this.inpMailAddressIsValid &&
        this.inpTitleIsValid &&
        this.inBodyIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'serviceRegistMailMagazineModal/hide'
    }),

    init () {

    },

    confirmData () {
      if (!this.formIsValid) return
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容でテスト配信しますか？',
        acceptLabel: '送信'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        serviceMailMagazineUuid: this.values.serviceMailMagazineUuid,
        request: {
          deliveryTestToMailAddress: this.inpMailAddress
        }
      }
      if (this.inpTitle !== null) {
        parameters.request.deliveryTestTitle = this.inpTitle
      }
      if (this.inpBody !== null) {
        parameters.request.deliveryTestMessage = this.inpBody
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceMailMagazine'],
        ['v1ServiceMailMagazineDeliveryTest'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'テスト配信',
              body: 'テスト配信しました。'
            })

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}